.group { position: relative; display: flex; border: var(--border-control); background: var(--paper); }
.option { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 8px 14px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; }
/* Descendant, not child: the indicator's label copies carry .option too and must stretch the same way. */
.group[data-block] { width: 100%; }
.group[data-block] .option { flex: 1; padding: 10px 12px; }

@media (max-width: 639px) {
  .option { flex: 1; min-height: 44px; padding: 0; font-size: 11px; }
  /* Stacked options share one left and right edge, so the sliding fill would cover them all: fill the pressed one instead. */
  .group[data-block] { flex-direction: column; }
  /* The HR model options kept their desktop 10px on phones. */
  .group[data-block] .option { padding: 0; font-size: 10px; }
  .group[data-block] > [aria-hidden='true'] { display: none; }
  .group[data-block] > .option[aria-pressed='true'] { background: var(--ink); color: var(--paper); }
}
